//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'BaseTag',
  props: {
    tag: {
      type: Object,
      default: () => ({})
    },
    inline: {
      type: Boolean,
      default: false
    },
    grey: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'regular',
      validator: val => [
        'regular',
        'small'
      ].includes(val)
    }
  },

  computed: {
    tagElement () {
      return this.tag && this.tag.url ? 'base-link' : 'span'
    },

    tagLink () {
      return this.tag && this.tag.url ? this.tag.url : null
    }
  }
}
